import React from 'react';
export function Chapter1() {
  return <section className="py-8 border-t border-gray-200" data-id="element-21">
      <h2 className="text-2xl font-bold mb-6" data-id="element-22">
        När orden försvann mitt i luften
      </h2>
      <p className="mb-4 text-lg" data-id="element-23">
        Det var ingen dramatisk scen. Bara en helt vanlig fredagskväll. Hemma
        hos oss doftade det rosmarin och vitlök från ugnen. Tre vänner satt vid
        köksön med varsitt glas vin, jag stod vid spisen och berättade om en bok
        jag precis läst. Ett stycke som hade träffat mig rakt i hjärtat.
      </p>
      <p className="mb-4 text-lg" data-id="element-24">
        Jag drog in luft, började formulera slutklämmen – och stannade. Vägen
        mellan tanke och ord var...{' '}
        <span className="font-semibold" data-id="element-25">avbruten</span>. Jag såg meningen
        framför mig som ett rep över ett dike, men när jag tog sats fanns ingen
        ände att greppa. Det blev tyst. Inte länge – men tillräckligt. Ett
        nervöst skratt, en ursäkt: "Vad var det jag skulle säga nu igen?" De log
        snällt. Den sortens snällhet man ger någon man tycker om, som just
        tappat tråden.
      </p>
      <div className="mb-6" data-id="element-26">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mq3JUUbfD17SYqpKEm3oeZ/2nd.webp" alt="Händer som sköljs under rinnande vatten i en diskho" className="w-full h-auto rounded-lg shadow-md object-cover" style={{
        height: '400px'
      }} width="1200" height="400" data-id="element-27" />
      </div>
      <p className="mb-4 text-lg" data-id="element-28">
        Den kvällen när alla gått stod jag kvar i köket, med händerna i
        diskvattnet och känslan av att ha blivit lite mindre av mig själv. Det
        här var inte första gången. Jag hade famlat efter namn, tappat ord mitt
        i meningar, glömt varför jag öppnat kylskåpet. Små saker, sa jag till
        mig själv. Men de små skaver när de staplas.
      </p>
      <p className="mb-4 text-lg" data-id="element-29">
        Morgonen efter satt jag med kaffekoppen och mindes hur det började.
        Först de små ögonblicken: att stå i mataffären och inte minnas vad jag
        skulle köpa, trots att jag bestämt mig för bara fem minuter sedan. Att
        behöva läsa samma stycke i en bok tre gånger. Att starta en mening och
        halvvägs in inse att jag glömt vad jag ville säga.
      </p>
      <p className="mb-4 text-lg" data-id="element-30">
        Min dotter Lina hade märkt det. "Mamma, du berättade det där igår
        också," sa hon vänligt när jag för tredje gången nämnde en artikel jag
        läst. Jag skrattade bort det. "Ålder är bara en siffra," sa jag. Men på
        nätterna låg jag vaken och undrade om det var så här det började –{' '}
        <span className="font-semibold text-gray-700" data-id="element-31">
          den långsamma förlusten av mig själv
        </span>
        .
      </p>
      <p className="mb-4 text-lg" data-id="element-32">
        Jag minns en onsdag i mars. Jag skulle hålla i ett mindre möte på
        jobbet. Jag hade förberett mig, antecknat punkter. Men när jag stod där
        framför mina kollegor var det som om någon blandat mina papper i
        huvudet. Jag famlade, hittade tillbaka, tappade tråden igen. "Förlåt,
        jag är lite trött idag," sa jag. De nickade förstående. Men jag såg
        blickarna de utbytte. Samma blickar jag själv gett äldre kollegor förr –
        en blandning av medkänsla och lätt oro.
      </p>
      <blockquote className="border-l-4 border-[#2e7d32] pl-4 italic my-6 text-lg" data-id="element-33">
        "Det var inte rädslan för att glömma som skrämde mig mest. Det var
        rädslan för att bli någon som andra måste{' '}
        <span className="not-italic font-semibold" data-id="element-34">anpassa sig till</span>.
        Någon som inte längre kan{' '}
        <span className="not-italic font-semibold" data-id="element-35">
          lita på sitt eget minne
        </span>
        ."
      </blockquote>
      <p className="mb-4 text-lg" data-id="element-36">
        Jag hade alltid varit den som höll i trådarna. Som kom ihåg
        födelsedagar, som kunde citera filmrepliker, som aldrig behövde skriva
        ner ett telefonnummer. Nu skrev jag listor. Listor på listor.
        Påminnelser i telefonen. Lappar på kylskåpet. Post-it på badrumsspegeln.
      </p>
      <p className="mb-4 text-lg" data-id="element-37">
        Det var efter den där fredagskvällen med vännerna som jag bestämde mig.
        Jag ville förstå vad som faktiskt händer i hjärnan – inte bara hälla mer
        kaffe över symptomen. Inte för fler appar. Inte för ännu en
        "mirakelkurs". Jag ville förstå vad som hände med mig, på riktigt.
      </p>
    </section>;
}